<div [ngClass]="{'row': !column, 'form-property':!column}"
     class="{{ !column && property?.styleClass ? property.styleClass : ''}}"
     >
  <div
    style="padding-right: 15px"
    [ngClass]="{'no-padding-right': tooltip||readonly, 'col-lg-10': tooltip && !column,  'col-lg-12': !tooltip && !column}"
  >
    <span [ngClass]="{'p-float-label':!column}">
      <input
        decimal
        id="{{name}}"
        type="text"
        style="-webkit-appearance: none; margin: 0"
        [ngStyle]="{'text-align': property ? (property.align || property.align ==0) ? (property.align==0?'center':(property.align==1 ? 'right':'left')) :'right'
                        : column.align? column.align:'right'}"
        [property]="property"
        [item]="item"
        [readonly]="readonly && !column || readonly && column
             &&   !(column.explicitEnabledParameterReference && item.parameters && item.parameters[column.explicitEnabledParameterReference])"
        [column]="column"
        [stringItem]="stringItem"
        (ngModelChange)="change($event)"
        class="table-control p-inputtext table-control-fill p-inputwrapper-focus p-inputwrapper-focus width-100"
        [(ngModel)]="stringItem.stringVal"
        [ngClass]="{'disabled':readonly && !column,'currencydisabled':(readonly && column
             &&   !(column.explicitEnabledParameterReference && item.parameters && item.parameters[column.explicitEnabledParameterReference]))
              || forceReadonly, 'property-invalid': (!readonly && notValid)}"
      />
      <label class="gs-float-label {{property?.labelClass ? property.labelClass : ''}}" [ngClass]="{'error-color':(!readonly && notValid)}"
        >{{label}}</label
      >
      <span
        *ngIf="property && (!readonly && notValid)"
        class="form-error"
        pTooltip="{{property.validationMessage}}"
      >
        <i class="fas fa-info-circle fa-2x form-valid-icon error-color"></i>
      </span>
    </span>
  </div>
  <div *ngIf="property && tooltip" class="col-lg-2 property-tooltip">
    <span pTooltip="{{property.tooltip}}">
      <i class="fas fa-info-circle master-color"></i>
    </span>
  </div>
</div>
